import { useState, useContext } from "react";
import UserContext from "../../contexts/userContext";

import Navbar from "react-bootstrap/Navbar"
import Button from "react-bootstrap/Button";
import Spinner from 'react-bootstrap/Spinner';
import Image from 'react-bootstrap/Image';
import { HelpModal } from "./2-3_HelpModal";
import { ConversationCards } from "./2-1_ConversationCards";
import { SettingsSidebar } from "./2-2_Settings";
import logo from "../../Primary white logo.png";

export const NavigationBar = () => {
    const { userContext, goHome } = useContext(UserContext);
    
    const [showSettingsSidebar, setShowSettingsSidebar] = useState(false);
    const [showHelpSidebar, setShowHelpSidebar] = useState(false);
    const [showConversationHistory, setShowConversationHistory] = useState(false);

    const isAuthenticated = userContext && userContext.account;
    const hasDocument = isAuthenticated && userContext.document;
    const hasConversation = isAuthenticated && userContext.conversationOverview;
    
    if (hasDocument && !hasConversation && !showConversationHistory) {
        setShowConversationHistory(true);
    }

    const doTour = userContext.tour;
    const backgroundClass = 'a8-dark-blue-background';
    
    return (
        <>
            <Navbar
                id="navbar"
                sticky={doTour ? "" : "top"}
                className="a8-dark-blue-background py-0"
            >
                
                {hasDocument ? <>
                    <Button
                        id="homeButton"
                        title="Home"
                        className="a8-dark-blue-background"
                        onClick={goHome}
                    >
                        {isAuthenticated ? (
                            <i className="bi-house-door-fill" />
                        ) : (
                            <Spinner animation="border" size="sm" />
                        )}    
                    </Button>
                    <Button 
                        id="conversationHistoryButton"
                        className={backgroundClass}
                        title={'Open conversation history'}
                        onClick={() => setShowConversationHistory(true)}
                    >
                        <i className={'bi-journal-text'} />
                    </Button>
                </> : <>
                    <Image
                        src={logo}
                        className="px-2"
                        style={{"height":"24px"}}
                    />
                </>}

                <div className="ms-auto">
                    <Button
                        id="helpButton"
                        onClick={() => setShowHelpSidebar(true)}
                        className={`${backgroundClass}`}
                    >
                        <i className="bi-question-circle" />
                    </Button>

                    <Button
                        id="settingsButton"
                        onClick={() => setShowSettingsSidebar(true)}
                        className={backgroundClass}
                    >
                        <i className="bi-gear" />
                    </Button>
                </div>
                
            </Navbar>

            <SettingsSidebar
                show={showSettingsSidebar}
                setShow={setShowSettingsSidebar}
            />
            
            {hasDocument && <ConversationCards
                show={showConversationHistory}
                setShowConversationHistory={setShowConversationHistory}
            />}

            <HelpModal showHelpSidebar={showHelpSidebar} setShowHelpSidebar={setShowHelpSidebar} />
        </>
    );
};